export default function Footer() {
  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'What is Signature', href: '#signature' },
    { label: 'Plans & Pricing', href: '#plans' },
    { label: 'Benefits', href: '#benefits' },
    { label: 'Contact', href: '#contact' },
  ];

  const services = [
    { label: 'Primary Care', href: '#benefits' },
    { label: 'Telehealth', href: '#benefits' },
    { label: 'Weight Management', href: '#benefits' },
    { label: 'Mental Health', href: '#benefits' },
    { label: 'IV Therapy', href: '#benefits' },
    { label: 'Lab Intelligence™', href: '#benefits' },
  ];

  const socials = [
    { icon: 'ri-facebook-fill', href: '#' },
    { icon: 'ri-twitter-x-fill', href: '#' },
    { icon: 'ri-instagram-fill', href: '#' },
    { icon: 'ri-linkedin-fill', href: '#' },
  ];

  return (
    <footer className="bg-[#0A2818] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/1aff587802347e8a3b9191c90eecded3/f49b2cbcc747a8cfb41259023b1a15e5.png"
              alt="Med-Care | Signature™"
              className="h-10 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Providing comprehensive healthcare services to the Nevada community with the Signature standard of care.
            </p>
            <div className="flex gap-2">
              {socials.map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-teal-600 rounded-lg transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-white/60 hover:text-teal-400 transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-teal-600 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-5">Services</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    className="text-sm text-white/60 hover:text-teal-400 transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-teal-600 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-white/60 leading-snug">
                  2121 E Flamingo Rd Ste 218<br />Las Vegas, NV 89119
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-teal-500 flex-shrink-0"></i>
                <a href="tel:702-723-0303" className="text-sm text-white/60 hover:text-teal-400 transition-colors cursor-pointer">
                  702.723.0303
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                <a href="mailto:signature@med-careproviders.com" className="text-sm text-white/60 hover:text-teal-400 transition-colors break-all cursor-pointer">
                  signature@med-careproviders.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-white/60 leading-snug">
                  Mon–Fri: 8AM–5PM<br />
                  Sat: 9AM–2PM<br />
                  Sun: Closed
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-xs">
              © 2025 Med-Care | Signature™. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-5 justify-center">
              {['Privacy Policy', 'Terms of Service', 'HIPAA Notice'].map((item) => (
                <a key={item} href="#" className="text-white/30 hover:text-teal-400 text-xs transition-colors cursor-pointer whitespace-nowrap">
                  {item}
                </a>
              ))}
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-teal-400 text-xs transition-colors cursor-pointer whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
